document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
        // Function to update ARIA attributes based on currentSwatch class
        function updateAriaAttributes() {
            const swatches = document.querySelectorAll('.webyzeProductColors .swatchProductColor');
            
            // Loop through each swatch
            swatches.forEach((swatch) => {
                // Remove aria-checked attribute from all swatches
                swatch.removeAttribute('aria-checked');
                
                // Set tabindex to 0 for all swatches
                swatch.setAttribute('tabindex', '0');
                
                // If the current swatch has the currentSwatch class
                if (swatch.classList.contains('currentSwatch')) {
                    // Set aria-checked to true
                    swatch.setAttribute('aria-checked', 'true');
                } else {
                    // Set aria-checked to false for other swatches
                    swatch.setAttribute('aria-checked', 'false');
                }
            });
        }
        
        // Call the update function after a delay to ensure dynamic content is loaded
        updateAriaAttributes();
    }, 1000); // Delay execution by 1 second (adjust as needed)
});
